export default __webpack_public_path__ + "static/media/proclamation12.bf1fe9dd.jpg";